module.exports = __webpack_public_path__ + "static/media/fleche_up.80a69a12.svg";